<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="tobbszerzVisible()" :attributes="tobbszerz" />

            <BnFormField v-if="csoportVisible()" :attributes="csoport" />

            <BnFormField v-if="csaladiVisible()" :attributes="csaladi" />

            <BnFormField v-if="egyuttcascoVisible()" :attributes="egyuttcasco" />

            <BnFormField v-if="felekezetiVisible()" :attributes="felekezeti" />

            <BnFormField v-if="homeOfficeVisible()" :attributes="homeoffice" />

            <BnFormField v-if="myGeneraliVisible()" :attributes="mygenerali" />

            <BnFormField v-if="kmallaIsmertVisible()" :attributes="kmallas"/>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';
import { CSEKK } from '../../../../../../../modules/FizetesiMod';
// eslint-disable-next-line no-unused-vars
import { LASSU, POTKOCSI } from '../../../../../../../modules/Gepjarmu';

export default {
    name: 'KedvezmenyekB2',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
        kmallaIsmertVisible() {
            return TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2023, 'kgfb', this.$store)
                && this.isSZGK();
        },
        myGeneraliVisible() {
            return this.$store.getters.tarifaData.egfb_regisztracio
                && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2022, 'kgfb', this.$store)
                && this.$store.getters.tarifaData.allianzemail
                && this.$store.getters.tarifaData.ajanl_fizmod_type !== CSEKK;
        },
        tobbszerzVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        csoportVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        egyuttcascoVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        csaladiVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        felekezetiVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        porscheVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        testuletVisible() {
            return this.getValue('tarifaData.ajanl_fizmod_type') !== 1;
        },
        testuletiChange() {
            this.shouldRecalc();
            this.$store.commit('setProp', {
                path: 'kedvezmenyekbiztosito.2.vip',
                value: false,
            });
        },
        vipChange() {
            this.shouldRecalc();
            this.$store.commit('setProp', {
                path: 'kedvezmenyekbiztosito.2.testuleti',
                value: false,
            });
        },
    },
    computed: {
        // TODO többi attribute-ot is computedba rakni
        egyuttcasco() {
            return {
                type: 'checkbox',
                label: 'CASCO együttkötés kedvezmény',
                editable: !this.disabled && !this.egyuttkotve,
                visible: true,
                rules: [],
                help: true,
                path: 'kedvezmenyekbiztosito.2.egyuttcasco',
                mezo: 'generali_egyuttcasco',
                change: this.shouldRecalc,
            };
        },
    },
    data() {
        return {
            tobbszerz: {
                type: 'checkbox',
                label: 'Több szerződés kedvezmény',
                editable: !this.disabled,
                visible: true,
                help: true,
                path: 'kedvezmenyekbiztosito.2.tobbszerz',
                mezo: 'generali_tobbszerz',
                change: this.shouldRecalc,
            },
            csoport: {
                type: 'checkbox',
                label: 'Generali csoport kedvezmény',
                editable: !this.disabled,
                visible: true,
                help: true,
                path: 'kedvezmenyekbiztosito.2.csoport',
                mezo: 'generali_csoport',
                change: this.shouldRecalc,
            },
            csaladi: {
                type: 'checkbox',
                label: 'Családi kedvezmény',
                editable: !this.disabled,
                visible: true,
                help: true,
                path: 'kedvezmenyekbiztosito.2.csaladi',
                mezo: 'generali_csaladi',
                change: this.shouldRecalc,
            },
            felekezeti: {
                type: 'checkbox',
                label: 'Felekezeti kedvezmény',
                editable: !this.disabled,
                visible: true,
                rules: [],
                help: true,
                path: 'kedvezmenyekbiztosito.2.felekezeti',
                mezo: 'generali_felekezeti',
                change: this.shouldRecalc,
            },
            homeoffice: {
                label: 'Home office kedvezmény',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekbiztosito.2.homeoffice',
                mezo: 'generali_homeoffice',
                change: this.shouldRecalc,
                help: true,
            },
            porsche: {
                type: 'checkbox',
                label: 'Porsche kedvezmény',
                editable: !this.disabled,
                visible: true,
                rules: [],
                help: true,
                path: 'kedvezmenyekbiztosito.2.porsche',
                mezo: 'generali_porsche',
                change: this.shouldRecalc,
            },
            testuleti: {
                type: 'checkbox',
                label: 'Testületi kedvezmény',
                editable: !this.disabled,
                visible: true,
                rules: [],
                help: true,
                path: 'kedvezmenyekbiztosito.2.testuleti',
                mezo: 'generali_testuleti',
                change: this.testuletiChange,
            },
            vip: {
                type: 'checkbox',
                label: 'VIP kedvezmény',
                editable: !this.disabled,
                visible: true,
                rules: [],
                help: true,
                path: 'kedvezmenyekbiztosito.2.vip',
                mezo: 'generali_vip',
                change: this.vipChange,
            },
            mygenerali: {
                type: 'checkbox',
                label: 'MyGenerali',
                editable: !this.disabled,
                visible: true,
                rules: [],
                help: true,
                path: 'kedvezmenyekbiztosito.2.mygenerali',
                mezo: 'generali_mygenerali',
                change: this.shouldRecalc,
            },
            kmallas: {
                type: 'checkbox',
                label: 'Évente az évforduló előtti 90 napban a km óra állás megadása',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.2.kmallas',
                mezo: 'generali_kmallas',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            },
        };
    },
};
</script>
